import React, { useContext, useEffect, useRef, useState } from "react";
import { VendorContext } from "../../../../../context/vendor/VendorContext";
import {
  CssNativeSelect,
  OptionSelect,
  CssTextField,
  ButtonUpload,
} from "../../style";
import { Button, Container, Column, ColumnButtons, Tittle } from "../style";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { FormControl, InputLabel } from "@mui/material";
import Wait from "../../../../Wait";
import { useTranslation } from "react-i18next";
import { Hr } from "./style";
import { AlertSpan } from "../step3/style";
import { ErrorOutline } from "@mui/icons-material";

const years = [];
for (let index = 1800; index <= new Date().getFullYear(); index++) {
  years[index - 1800] = { id: index, value: index };
}
const Step1 = () => {
  const { t } = useTranslation();
  const [nonNumber, setNonNumber] = useState(false);
  const [isLoading, setLoading] = useState(true);
  const {
    steps,
    vendorInformation,
    companyInformation,
    vendDocumentation,
    vendFlowEnrollment,
    contactPerson,
    logisticsPostalAddress,
    activeStep,
    listProvince,
    listCity,
    listTypeContact,
    setActiveStep,
    getCompanyInformation,
    getListProvince,
    getListCity,
    getListTypeContact,
    getBase64,
    sendCompanyInformation,
    sendLogisticsPostalAddress,
    sendContactPerson,
    sendVendDocumentation,
    sendVendFlowEnrollment,
    sendVendorInformation,
  } = useContext(VendorContext);
  const uploadCedula = useRef(null);
  const uploadRegistroUnico = useRef(null);
  const uploadDeclaracionImpRenta = useRef(null);
  const uploadObligacionesIESS = useRef(null);
  const uploadReferenciaClientes = useRef(null);
  const uploadNombramientoRepLegal = useRef(null);
  const handleNext = () => {
    setActiveStep(activeStep + 1);
  };
  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };
  const handleUpload = (e, tag) => {
    e.preventDefault();
    if (tag === 1) {
      uploadCedula.current.click();
    } else if (tag === 2) {
      uploadRegistroUnico.current.click();
    } else if (tag === 3) {
      uploadDeclaracionImpRenta.current.click();
    } else if (tag === 4) {
      uploadObligacionesIESS.current.click();
    } else if (tag === 5) {
      uploadReferenciaClientes.current.click();
    } else if (tag === 6) {
      uploadNombramientoRepLegal.current.click();
    }
  };
  const handleFileUpload = (event) => {
    const fileUploaded = event.target.files[0];
    getBase64(fileUploaded)
      .then((data) => {
        vendDocumentation[event.target.name] = data;
        sendVendDocumentation(vendDocumentation);
      })
      .catch((error) => {
        alert("Error: " + error.currentTarget.error);
      });
  };

  const handleAttachmentReason = (event) => {
    vendDocumentation[event.target.name] = event.target.value;
    sendVendDocumentation(vendDocumentation);
  };
  const handleInformation = (event) => {
    event.preventDefault();
    if (event.target.name === "ruc") {
      vendorInformation[event.target.name] = event.target.value;
      sendVendorInformation(vendorInformation);
    }
    companyInformation[event.target.name] = event.target.value;
    sendCompanyInformation(companyInformation);
  };
  const handleLogisticsAddressInformation = (event) => {
    event.preventDefault();
    logisticsPostalAddress[event.target.name] = event.target.value;
    sendLogisticsPostalAddress(logisticsPostalAddress);
  };
  const handleContactPersonInformation0 = (event, contact) => {
    event.preventDefault();
    if (vendorInformation.country === "ECU") {
      if (event.target.name === "phone" && isNaN(event.target.value)) {
        setNonNumber(true);
      } else if (
        event.target.name === "phone" &&
        event.target.value.length <= 10
      ) {
        contact[event.target.name] = event.target.value;
        setNonNumber(false);
        sendContactPerson(contact);
      } else {
        contact[event.target.name] = event.target.value;
        setNonNumber(false);
        sendContactPerson(contact);
      }
    } else {
      contact[event.target.name] = event.target.value;
      setNonNumber(false);
      sendContactPerson(contact);
    }
  };

  const submitForm = async (e) => {
    e.preventDefault();
    if (vendorInformation.country === "ECU") {
      vendorInformation["ruc"] = companyInformation["ruc"];
      await sendVendorInformation(vendorInformation);
    }
    if (vendFlowEnrollment.lasT_STEP === activeStep) {
      vendFlowEnrollment["lasT_STEP"] = vendFlowEnrollment.lasT_STEP + 1;
      await Promise.all([sendVendFlowEnrollment(vendFlowEnrollment)]);
    }
    handleNext();
  };

  useEffect(() => {
    const fetchData2 = async () => {
      await Promise.all([getCompanyInformation()]);
      if (vendorInformation.country === "ECU") {
        await Promise.all([getListProvince(vendorInformation.country)]);
      }
      setLoading(false);
    };
    fetchData2();
  }, []);

  useEffect(() => {
    const fetchData2 = async () => {
      if (vendorInformation.country === "ECU") {
        await Promise.all([getListCity(logisticsPostalAddress.province)]);
      }
    };
    fetchData2();
  }, [logisticsPostalAddress.province]);

  if (isLoading) {
    return <Wait />;
  }
  return (
    <>
      <form
        onSubmit={(e) => {
          submitForm(e);
        }}
      >
        <Tittle>{t(steps[0])}</Tittle>
        <Container>
          {vendorInformation.country === "ECU" ? (
            <Column>
              <CssTextField
                type={"text"}
                value={companyInformation.businesS_NAME}
                required={true}
                fullWidth
                label={t("businessName") + " (" + t("sriNotice") + ")"}
                id="businesS_NAME"
                name="businesS_NAME"
                onChange={(e) => handleInformation(e)}
              />
            </Column>
          ) : (
            <Column>
              <CssTextField
                type={"text"}
                value={companyInformation.businesS_NAME}
                required={true}
                fullWidth
                label={t("businessName")}
                id="businesS_NAME"
                name="businesS_NAME"
                onChange={(e) => handleInformation(e)}
              />
            </Column>
          )}

          {vendorInformation.country === "ECU" && (
            <Column>
              <CssTextField
                type={"text"}
                value={companyInformation.ruc}
                required={true}
                fullWidth
                label={t("ruc") + " (" + t("sriNotice") + ")"}
                id="ruc"
                name="ruc"
                onChange={(e) => handleInformation(e)}
              />
            </Column>
          )}
          <Column>
            <FormControl required fullWidth>
              <InputLabel variant="standard">{t("foundationYear")}</InputLabel>
              <CssNativeSelect
                value={companyInformation.fundatioN_YEAR}
                name="fundatioN_YEAR"
                id="fundatioN_YEAR"
                onChange={(e) => handleInformation(e)}
              >
                {years.map((item) => (
                  <OptionSelect key={item.id} value={item.id}>
                    {item.value}
                  </OptionSelect>
                ))}
              </CssNativeSelect>
            </FormControl>
          </Column>
          <Column>
            <CssTextField
              type={"text"}
              value={logisticsPostalAddress.address}
              required={true}
              fullWidth
              label={t("address")}
              id="address"
              name="address"
              onChange={(e) => handleLogisticsAddressInformation(e)}
            />
          </Column>
          {vendorInformation.country === "ECU" && (
            <Column>
              <FormControl required fullWidth>
                <InputLabel>{t("province")}</InputLabel>
                <CssNativeSelect
                  value={logisticsPostalAddress.province}
                  id="province"
                  name="province"
                  onChange={(e) => handleLogisticsAddressInformation(e)}
                >
                  <OptionSelect></OptionSelect>
                  {listProvince.map((item) => (
                    <OptionSelect key={item.countyId} value={item.countyId}>
                      {item.name}
                    </OptionSelect>
                  ))}
                </CssNativeSelect>
              </FormControl>
            </Column>
          )}
          {vendorInformation.country === "ECU" ? (
            <Column>
              <FormControl required fullWidth>
                <InputLabel>{t("city")}</InputLabel>
                <CssNativeSelect
                  value={logisticsPostalAddress.city}
                  id="city"
                  name="city"
                  label={t("city") + " *"}
                  onChange={(e) => handleLogisticsAddressInformation(e)}
                >
                  <OptionSelect></OptionSelect>
                  {listCity.map((item) => (
                    <OptionSelect key={item.name} value={item.name}>
                      {item.description}
                    </OptionSelect>
                  ))}
                </CssNativeSelect>
              </FormControl>
            </Column>
          ) : (
            <Column>
              <CssTextField
                type={"text"}
                value={logisticsPostalAddress.city}
                required={true}
                fullWidth
                label={t("city")}
                id="city"
                name="city"
                onChange={(e) => handleLogisticsAddressInformation(e)}
              />
            </Column>
          )}
          <Column>
            <CssTextField
              type={"text"}
              value={logisticsPostalAddress.postaL_CODE}
              required={true}
              fullWidth
              label={t("postalCode")}
              id="postaL_CODE"
              name="postaL_CODE"
              onChange={(e) => handleLogisticsAddressInformation(e)}
            />
          </Column>
          <Column>
            <CssTextField
              type={"email"}
              value={companyInformation.email}
              required={true}
              fullWidth
              label={t("email")}
              id="email"
              name="email"
              onChange={(e) => handleInformation(e)}
            />
          </Column>
          <Column>
            <CssTextField
              type={"number"}
              value={companyInformation.nuM_EMPLOYEES}
              required={false}
              fullWidth
              inputProps={{ min: 0 }}
              label={t("numEmployee")}
              id="nuM_EMPLOYEES"
              name="nuM_EMPLOYEES"
              onChange={(e) => handleInformation(e)}
            />
          </Column>
          <Column>
            <CssTextField
              type={"text"}
              required={false}
              value={companyInformation.urL_SITE}
              fullWidth
              label={t("webSiteUrl")}
              id="urL_SITE"
              name="urL_SITE"
              onChange={(e) => handleInformation(e)}
            />
          </Column>
        </Container>
        {contactPerson.length > 0 && (
          <>
            <Tittle>{t("contactPerson")}</Tittle>
            {contactPerson.map((item, index) => {
              return (
                <div key={index}>
                  <Hr />
                  <Container>
                    <Column>
                      <CssTextField
                        type={"text"}
                        value={
                          listTypeContact.filter((x) => x.code === item.type)[0]
                            .description
                        }
                        required={true}
                        fullWidth
                        label={t("type")}
                        id="type"
                        name="type"
                        disabled
                        // onChange={(e) => handleContactPersonInformation0(e)}
                      />
                    </Column>
                    <Column>
                      <CssTextField
                        type={"text"}
                        value={item.name}
                        required={true}
                        fullWidth
                        label={t("fullName")}
                        id="name"
                        name="name"
                        onChange={(e) =>
                          handleContactPersonInformation0(e, item)
                        }
                      />
                    </Column>
                    <Column>
                      <CssTextField
                        type={"text"}
                        value={item.position}
                        required={true}
                        fullWidth
                        label={t("position")}
                        id="position"
                        name="position"
                        onChange={(e) =>
                          handleContactPersonInformation0(e, item)
                        }
                      />
                    </Column>
                    <Column>
                      <CssTextField
                        type={"text"}
                        value={item.area}
                        required={true}
                        fullWidth
                        label={t("area")}
                        id="area"
                        name="area"
                        onChange={(e) =>
                          handleContactPersonInformation0(e, item)
                        }
                      />
                    </Column>
                    <Column>
                      <CssTextField
                        type={"text"}
                        value={item.phone}
                        required={true}
                        fullWidth
                        label={t("phone")}
                        id="phone"
                        name="phone"
                        onChange={(e) =>
                          handleContactPersonInformation0(e, item)
                        }
                      />
                      {nonNumber && item.phone === "" && (
                        <AlertSpan>
                          <ErrorOutline /> {t("incorrectValue")}
                        </AlertSpan>
                      )}
                    </Column>
                    <Column>
                      <CssTextField
                        type={"text"}
                        value={item.email}
                        required={true}
                        fullWidth
                        label={t("email")}
                        id="email"
                        name="email"
                        onChange={(e) =>
                          handleContactPersonInformation0(e, item)
                        }
                      />
                    </Column>
                  </Container>
                </div>
              );
            })}
          </>
        )}
        {vendorInformation.country === "ECU" && (
          <>
            <Tittle>{t("documentation")}</Tittle>
            <Container>
              <Column>
                <ButtonUpload
                  disabled={vendDocumentation.cedulA_RZ}
                  onClick={(e) => handleUpload(e, 1)}
                >
                  {t("copyID")}
                  <UploadFileIcon />
                </ButtonUpload>
                <input
                  type="file"
                  accept="application/pdf"
                  name={"cedula"}
                  ref={uploadCedula}
                  onChange={(e) => handleFileUpload(e)}
                  style={{ display: "none" }}
                />
                {!vendDocumentation.cedula && (
                  <>
                    <br />
                    <br />
                    <CssTextField
                      required={!vendDocumentation.cedula}
                      value={vendDocumentation.cedulA_RZ}
                      name="cedulA_RZ"
                      fullWidth
                      label={t("reasonNotAttach")}
                      onChange={(e) => handleAttachmentReason(e)}
                    />
                  </>
                )}
              </Column>
              <Column>
                <ButtonUpload
                  disabled={vendDocumentation.obligacioneS_IESS_RZ}
                  onClick={(e) => handleUpload(e, 4)}
                >
                  {t("obligationsIessSri")}
                  <UploadFileIcon />
                </ButtonUpload>
                <input
                  type="file"
                  accept="application/pdf"
                  name={"obligacioneS_IESS"}
                  ref={uploadObligacionesIESS}
                  onChange={(e) => handleFileUpload(e)}
                  style={{ display: "none" }}
                />
                {!vendDocumentation.obligacioneS_IESS && (
                  <>
                    <br />
                    <br />
                    <CssTextField
                      required={!vendDocumentation.obligacioneS_IESS}
                      value={vendDocumentation.obligacioneS_IESS_RZ}
                      name="obligacioneS_IESS_RZ"
                      fullWidth
                      label={t("reasonNotAttach")}
                      onChange={(e) => handleAttachmentReason(e)}
                    />
                  </>
                )}
              </Column>
              <Column>
                <ButtonUpload
                  disabled={vendDocumentation.registrO_UNICO_RZ}
                  onClick={(e) => handleUpload(e, 2)}
                >
                  {t("copyRuc")}
                  <UploadFileIcon />
                </ButtonUpload>
                <input
                  type="file"
                  accept="application/pdf"
                  name={"registrO_UNICO"}
                  ref={uploadRegistroUnico}
                  onChange={(e) => handleFileUpload(e)}
                  style={{ display: "none" }}
                />
                {!vendDocumentation.registrO_UNICO && (
                  <>
                    <br />
                    <br />
                    <CssTextField
                      required={!vendDocumentation.registrO_UNICO}
                      value={vendDocumentation.registrO_UNICO_RZ}
                      name="registrO_UNICO_RZ"
                      fullWidth
                      label={t("reasonNotAttach")}
                      onChange={(e) => handleAttachmentReason(e)}
                    />
                  </>
                )}
              </Column>
              <Column>
                <ButtonUpload
                  disabled={vendDocumentation.referenciA_CLIENTES_RZ}
                  onClick={(e) => handleUpload(e, 5)}
                >
                  {t("referencesClients")}
                  <UploadFileIcon />
                </ButtonUpload>
                <input
                  type="file"
                  accept="application/pdf"
                  name={"referenciA_CLIENTES"}
                  ref={uploadReferenciaClientes}
                  onChange={(e) => handleFileUpload(e)}
                  style={{ display: "none" }}
                />
                {!vendDocumentation.referenciA_CLIENTES && (
                  <>
                    <br />
                    <br />
                    <CssTextField
                      required={!vendDocumentation.referenciA_CLIENTES}
                      value={vendDocumentation.referenciA_CLIENTES_RZ}
                      name="referenciA_CLIENTES_RZ"
                      fullWidth
                      label={t("reasonNotAttach")}
                      onChange={(e) => handleAttachmentReason(e)}
                    />
                  </>
                )}
              </Column>
              {vendorInformation.type === "2" && (
                <Column>
                  <ButtonUpload
                    disabled={
                      vendDocumentation.nombramientO_REPRESENTANTE_LEGAL_RZ
                    }
                    onClick={(e) => handleUpload(e, 6)}
                  >
                    {t("docLegalRep")}
                    <UploadFileIcon />
                  </ButtonUpload>
                  <input
                    type="file"
                    accept="application/pdf"
                    name={"nombramientO_REPRESENTANTE_LEGAL"}
                    ref={uploadNombramientoRepLegal}
                    onChange={(e) => handleFileUpload(e)}
                    style={{ display: "none" }}
                  />
                  {!vendDocumentation.nombramientO_REPRESENTANTE_LEGAL && (
                    <>
                      <br />
                      <br />
                      <CssTextField
                        required={
                          !vendDocumentation.nombramientO_REPRESENTANTE_LEGAL
                        }
                        value={
                          vendDocumentation.nombramientO_REPRESENTANTE_LEGAL_RZ
                        }
                        name="nombramientO_REPRESENTANTE_LEGAL_RZ"
                        fullWidth
                        label={t("reasonNotAttach")}
                        onChange={(e) => handleAttachmentReason(e)}
                      />
                    </>
                  )}
                </Column>
              )}
            </Container>
          </>
        )}
        <Container>
          <ColumnButtons>
            <Button onClick={handleBack}>{t("back")}</Button>
          </ColumnButtons>
          <ColumnButtons>
            <Button>{t("next")}</Button>
          </ColumnButtons>
        </Container>
      </form>
    </>
  );
};

export default Step1;
